import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormControl, NgControl, NgModel, FormsModule } from '@angular/forms';
import * as i1 from '@capturum/ui/api';
import { ValueAccessorBase, CapturumTemplateDirective, CapturumSharedModule } from '@capturum/ui/api';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as i4 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i5 from 'primeng/api';
const _c0 = ["pMultiSelect"];
function CapturumMultiSelectComponent_label_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.label);
  }
}
const _c1 = function (a0) {
  return {
    "justify-content": a0
  };
};
function CapturumMultiSelectComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_label_1_span_1_Template, 2, 1, "span", 6);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(3, _c1, ctx_r0.label ? "space-between" : "flex-end"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.label);
  }
}
function CapturumMultiSelectComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CapturumMultiSelectComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
  }
}
function CapturumMultiSelectComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CapturumMultiSelectComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.label);
  }
}
const _c2 = function (a0) {
  return {
    $implicit: a0
  };
};
function CapturumMultiSelectComponent_ng_template_5_ng_container_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 13);
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r15.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, item_r16));
  }
}
function CapturumMultiSelectComponent_ng_template_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_template_5_ng_container_2_ng_template_1_Template, 1, 4, "ng-template", 12);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumMultiSelectComponent_ng_template_5_ng_container_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 13);
  }
  if (rf & 2) {
    const items_r18 = ctx.$implicit;
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r17.selectedItemsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, items_r18));
  }
}
function CapturumMultiSelectComponent_ng_template_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_template_5_ng_container_3_ng_template_1_Template, 1, 4, "ng-template", 14);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumMultiSelectComponent_ng_template_5_ng_container_4_ng_template_1_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMapInterpolate1("p-multiselected-icon ", ctx_r21.icon, "");
  }
}
const _c3 = function (a0) {
  return {
    "p-multiselected-empty-token p-corner-all": a0
  };
};
function CapturumMultiSelectComponent_ng_template_5_ng_container_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_template_5_ng_container_4_ng_template_1_i_1_Template, 1, 3, "i", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r20 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, !items_r20 || items_r20.length === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", !items_r20 || (items_r20 == null ? null : items_r20.length) === 0 ? ctx_r19.defaultLabel : ctx_r19.interpolatedSelectedLabel, " ");
  }
}
function CapturumMultiSelectComponent_ng_template_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumMultiSelectComponent_ng_template_5_ng_container_4_ng_template_1_Template, 3, 5, "ng-template", 14);
    i0.ɵɵelementContainerEnd();
  }
}
function CapturumMultiSelectComponent_ng_template_5_p_footer_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-footer");
    i0.ɵɵelementContainer(1, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r14.footerTemplate);
  }
}
function CapturumMultiSelectComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-multiSelect", 10, 11);
    i0.ɵɵlistener("onBlur", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onBlur_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.blur.emit($event));
    })("onChange", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.onChange($event));
    })("onClick", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.click.emit($event));
    })("onFocus", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onFocus_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.focus.emit($event));
    })("onFilter", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onFilter_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.filtered.emit($event));
    })("onPanelShow", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onPanelShow_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.panelShow.emit($event));
    })("onPanelHide", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_onPanelHide_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.panelHide.emit($event));
    })("ngModelChange", function CapturumMultiSelectComponent_ng_template_5_Template_p_multiSelect_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.value = $event);
    });
    i0.ɵɵtemplate(2, CapturumMultiSelectComponent_ng_template_5_ng_container_2_Template, 2, 0, "ng-container", 6);
    i0.ɵɵtemplate(3, CapturumMultiSelectComponent_ng_template_5_ng_container_3_Template, 2, 0, "ng-container", 6);
    i0.ɵɵtemplate(4, CapturumMultiSelectComponent_ng_template_5_ng_container_4_Template, 2, 0, "ng-container", 6);
    i0.ɵɵtemplate(5, CapturumMultiSelectComponent_ng_template_5_p_footer_5_Template, 2, 1, "p-footer", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("readonly", ctx_r5.readonly);
    i0.ɵɵproperty("ngModel", ctx_r5.value)("appendTo", ctx_r5.appendTo)("placeholder", ctx_r5.defaultLabel)("disabled", ctx_r5.disabled)("filterBy", ctx_r5.filterBy)("filterPlaceHolder", ctx_r5.filterPlaceHolder)("filter", ctx_r5.filter)("inputId", ctx_r5.inputId)("virtualScrollItemSize", ctx_r5.virtualScrollItemSize)("options", ctx_r5.options)("optionLabel", ctx_r5.optionLabel)("optionValue", ctx_r5.optionValue)("dataKey", ctx_r5.dataKey)("showToggleAll", ctx_r5.showToggleAll)("panelStyleClass", "cap-multi-select-panel " + ctx_r5.panelStyleClass)("readonly", ctx_r5.readonly)("selectionLimit", ctx_r5.selectionLimit)("scrollHeight", ctx_r5.scrollHeight)("dropdownIcon", ctx_r5.dropdownIcon)("showHeader", ctx_r5.showHeader)("displaySelectedLabel", ctx_r5.displaySelectedLabel)("maxSelectedLabels", ctx_r5.maxSelectedLabels)("resetFilterOnHide", ctx_r5.resetFilterOnHide)("selectedItemsLabel", ctx_r5.selectedItemsLabel)("styleClass", "cap-multi-select " + ctx_r5.styleClass)("group", ctx_r5.group)("display", ctx_r5.display)("optionGroupLabel", ctx_r5.optionGroupLabel)("optionGroupChildren", ctx_r5.optionGroupChildren)("virtualScroll", ctx_r5.virtualScroll)("autofocusFilter", ctx_r5.autofocusFilter);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.itemTemplate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedItemsTemplate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.selectedItemsTemplate && ctx_r5.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.footerTemplate);
  }
}
function CapturumMultiSelectComponent_cap_validator_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cap-validator", 18);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r6.control)("customName", ctx_r6.label);
  }
}
const _c4 = [[["", 8, "tooltip-content"]]];
const _c5 = [".tooltip-content"];
let CapturumMultiSelectComponent = /*#__PURE__*/(() => {
  class CapturumMultiSelectComponent extends ValueAccessorBase {
    constructor(injector, validatorService) {
      super();
      this.injector = injector;
      this.validatorService = validatorService;
      /**
       * Sort the options alphabetically
       */
      this.sortAlphabetically = true;
      /**
       * Define the property the options should be sorted by. Works in combination with sortAlphabetically
       */
      this.sortBy = 'label';
      /**
       * Height of the viewport in pixels, a scrollbar is defined if height of list exceeds this value
       */
      this.scrollHeight = '200px';
      /**
       * Style class of the element
       */
      this.styleClass = '';
      /**
       * Style class of the overlay panel
       */
      this.panelStyleClass = '';
      /**
       * When specified, displays an input field to filter the items on keyup
       */
      this.filter = true;
      /**
       * Whether to show labels of selected item labels or use default label
       */
      this.displaySelectedLabel = true;
      /**
       * Decides how many selected item labels to show at most
       */
      this.maxSelectedLabels = 3;
      /**
       * Label to display after exceeding max selected labels
       */
      this.selectedItemsLabel = '{0} items selected';
      /**
       * Whether to show the checkbox at header to toggle all items at once
       */
      this.showToggleAll = true;
      /**
       * Clears the filter value when hiding the dropdown
       */
      this.resetFilterOnHide = false;
      /**
       * Icon class of the dropdown icon
       */
      this.dropdownIcon = 'pi pi-chevron-down';
      /**
       * Whether to show the header
       */
      this.showHeader = true;
      /**
       * Whether to automatically manage layering
       */
      this.autoZIndex = true;
      /**
       * Base zIndex value to use in layering
       */
      this.baseZIndex = 0;
      /**
       * When filtering is enabled, filterBy decides which field or fields (comma separated) to search against
       */
      this.filterBy = 'label';
      /**
       Whether the data should be loaded on demand during scroll
       */
      this.virtualScroll = false;
      /**
       * Height of an item in the list for VirtualScrolling
       */
      this.virtualScrollItemSize = 34;
      /**
       * Transition options of the show animation
       */
      this.showTransitionOptions = '225ms ease-out';
      /**
       * Transition options of the hide animation
       */
      this.hideTransitionOptions = '195ms ease-in';
      /**
       * Set to chip to display the selected items in a chips display
       */
      this.display = 'comma';
      /**
       * Name of the label field of an option group.
       */
      this.optionGroupLabel = 'label';
      /**
       * Name of the options field of an option group.
       */
      this.optionGroupChildren = 'items';
      /**
       * Applies focus to the filter element when the overlay is shown.
       */
      this.autofocusFilter = true;
      /**
       * Float label
       */
      this.floatLabel = false;
      /**
       * Callback to invoke when value changes
       */
      this.change = new EventEmitter();
      /**
       * Callback to invoke when multiselect receives focus
       */
      this.focus = new EventEmitter();
      /**
       * Callback to invoke when multiselect loses focus
       */
      this.blur = new EventEmitter();
      /**
       * Callback to invoke when component is clicked
       */
      this.click = new EventEmitter();
      /**
       * Callback to invoke when component is filtered
       */
      this.filtered = new EventEmitter();
      /**
       * Callback to invoke when overlay panel becomes visible
       */
      this.panelShow = new EventEmitter();
      /**
       * Callback to invoke when overlay panel becomes hidden
       */
      this.panelHide = new EventEmitter();
      this.control = new FormControl();
      this.subscription = new Subscription();
      this._options = [];
    }
    get options() {
      return this._options;
    }
    /**
     * An array of objects to display as the available options
     *
     * @param options
     */
    set options(options) {
      if (Array.isArray(options)) {
        this._options = options;
      } else {
        this._options = [];
      }
    }
    ngOnChanges() {
      if (this.options && this.sortAlphabetically) {
        this.options = this.sortOptionsAlphabetically(this.options);
      }
    }
    ngOnInit() {
      this.subscription = this.control.valueChanges.pipe(debounceTime(333)).subscribe(() => {
        if (this.icon) {
          this.setSelectedItems();
        }
      });
    }
    ngAfterViewInit() {
      setTimeout(() => {
        const ngControl = this.injector.get(NgControl, null);
        this.control = this.validatorService.extractFormControl(ngControl);
        if (this.icon) {
          this.setSelectedItems();
        }
      });
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    /**
     * Switch templates based on the content children
     */
    ngAfterContentInit() {
      this.templates.forEach(template => {
        switch (template.getType()) {
          case 'item':
            this.itemTemplate = template.template;
            break;
          case 'selectedItems':
            this.selectedItemsTemplate = template.template;
            break;
          case 'footer':
            this.footerTemplate = template.template;
            break;
        }
      });
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    setSelectedItems() {
      /* Example of string: {0} items selected */
      const pattern = /{(.*?)}/;
      if (this.value) {
        if (this.value.length >= this.maxSelectedLabels && pattern.test(this.selectedItemsLabel)) {
          this.interpolatedSelectedLabel = this.selectedItemsLabel.replace(this.selectedItemsLabel.match(pattern)[0], this.value.length + '');
        } else {
          const selectedOptions = this.options.filter(item => this.value.includes(item.value));
          this.interpolatedSelectedLabel = selectedOptions.reduce((acc, item, index) => {
            const prefix = !index ? ' ' : ', ';
            return acc += `${prefix}${item.label}`;
          }, '');
        }
      }
    }
    onChange($event) {
      if (this.icon) {
        this.setSelectedItems();
      }
      this.change.emit($event);
    }
    hide() {
      this.pMultiSelect.hide();
    }
    sortOptionsAlphabetically(options) {
      return options.sort((a, b) => {
        if (!a[this.sortBy] || !b[this.sortBy]) {
          return 0;
        }
        return a[this.sortBy].toLowerCase() > b[this.sortBy].toLowerCase() ? 1 : -1;
      });
    }
    static {
      this.ɵfac = function CapturumMultiSelectComponent_Factory(t) {
        return new (t || CapturumMultiSelectComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.ValidatorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumMultiSelectComponent,
        selectors: [["cap-multi-select"]],
        contentQueries: function CapturumMultiSelectComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function CapturumMultiSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(NgModel, 7);
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.model = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pMultiSelect = _t.first);
          }
        },
        inputs: {
          sortAlphabetically: "sortAlphabetically",
          sortBy: "sortBy",
          scrollHeight: "scrollHeight",
          style: "style",
          styleClass: "styleClass",
          panelStyle: "panelStyle",
          panelStyleClass: "panelStyleClass",
          inputId: "inputId",
          disabled: "disabled",
          readonly: "readonly",
          required: "required",
          filter: "filter",
          filterPlaceHolder: "filterPlaceHolder",
          overlayVisible: "overlayVisible",
          tabindex: "tabindex",
          appendTo: "appendTo",
          dataKey: "dataKey",
          name: "name",
          displaySelectedLabel: "displaySelectedLabel",
          maxSelectedLabels: "maxSelectedLabels",
          selectionLimit: "selectionLimit",
          selectedItemsLabel: "selectedItemsLabel",
          showToggleAll: "showToggleAll",
          resetFilterOnHide: "resetFilterOnHide",
          dropdownIcon: "dropdownIcon",
          optionLabel: "optionLabel",
          optionValue: "optionValue",
          showHeader: "showHeader",
          autoZIndex: "autoZIndex",
          baseZIndex: "baseZIndex",
          filterBy: "filterBy",
          virtualScroll: "virtualScroll",
          virtualScrollItemSize: "virtualScrollItemSize",
          showTransitionOptions: "showTransitionOptions",
          hideTransitionOptions: "hideTransitionOptions",
          ariaFilterLabel: "ariaFilterLabel",
          label: "label",
          defaultLabel: "defaultLabel",
          icon: "icon",
          hasTooltip: "hasTooltip",
          display: "display",
          group: "group",
          optionGroupLabel: "optionGroupLabel",
          optionGroupChildren: "optionGroupChildren",
          autofocusFilter: "autofocusFilter",
          floatLabel: "floatLabel",
          options: "options"
        },
        outputs: {
          change: "change",
          focus: "focus",
          blur: "blur",
          click: "click",
          filtered: "filtered",
          panelShow: "panelShow",
          panelHide: "panelHide"
        },
        features: [i0.ɵɵProvidersFeature([ValueAccessorBase.getProviderConfig(CapturumMultiSelectComponent)]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c5,
        decls: 8,
        vars: 4,
        consts: [[1, "form-element"], [3, "style", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["floatingInput", ""], ["defaultTemplate", ""], [3, "control", "customName", 4, "ngIf"], [4, "ngIf"], [4, "ngTemplateOutlet"], [1, "p-float-label", "multi-select-float-label"], ["htmlFor", "float-label", 1, "cpb-float-label"], [3, "ngModel", "appendTo", "placeholder", "disabled", "filterBy", "filterPlaceHolder", "filter", "inputId", "virtualScrollItemSize", "options", "optionLabel", "optionValue", "dataKey", "showToggleAll", "panelStyleClass", "readonly", "selectionLimit", "scrollHeight", "dropdownIcon", "showHeader", "displaySelectedLabel", "maxSelectedLabels", "resetFilterOnHide", "selectedItemsLabel", "styleClass", "group", "display", "optionGroupLabel", "optionGroupChildren", "virtualScroll", "autofocusFilter", "onBlur", "onChange", "onClick", "onFocus", "onFilter", "onPanelShow", "onPanelHide", "ngModelChange"], ["pMultiSelect", ""], ["pTemplate", "item"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["pTemplate", "selectedItems"], [3, "ngClass"], [3, "class", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "control", "customName"]],
        template: function CapturumMultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumMultiSelectComponent_label_1_Template, 3, 5, "label", 1);
            i0.ɵɵtemplate(2, CapturumMultiSelectComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, CapturumMultiSelectComponent_ng_template_3_Template, 4, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, CapturumMultiSelectComponent_ng_template_5_Template, 6, 37, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, CapturumMultiSelectComponent_cap_validator_7_Template, 1, 2, "cap-validator", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const _r2 = i0.ɵɵreference(4);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.label || ctx.hasTooltip) && !ctx.floatLabel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.floatLabel)("ngIfElse", _r2);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.control);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i3.NgControlStatus, i3.NgModel, i4.MultiSelect, i5.Footer, i5.PrimeTemplate, i1.CapturumValidatorComponent],
        styles: ["[_nghost-%COMP%]     .em-multi-select-panel .apply-filter-button{width:calc(100% - 1rem)}"]
      });
    }
  }
  return CapturumMultiSelectComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumMultiSelectModule = /*#__PURE__*/(() => {
  class CapturumMultiSelectModule {
    static {
      this.ɵfac = function CapturumMultiSelectModule_Factory(t) {
        return new (t || CapturumMultiSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumMultiSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, MultiSelectModule, CapturumSharedModule]
      });
    }
  }
  return CapturumMultiSelectModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumMultiSelectComponent, CapturumMultiSelectModule };
